import React from "react"

const rootCss = theme => ({
  display: `grid`,
  gridTemplateAreas: `
    "statusIcon statusText"
    "deployIcon deployText"
    "startTime  startTime"
    "buildUrl   buildUrl"
    "cdnVendor  cdnVendor"
    "eventInfo  eventInfo"
    "logs       logs"
    "lighthouse lighthouse"
  `,
  gridTemplateColumns: `2rem auto`,
  gridRowGap: theme.space[3],
  fontSize: theme.fontSizes[1],
  [theme.mediaQueries.phablet]: {
    gridTemplateColumns: `auto`,
    gridTemplateAreas: `
      "statusIcon statusText startTime"
      "deployIcon deployText cdnVendor"
      "buildUrl   buildUrl   buildUrl"
      "eventInfo  eventInfo  eventInfo"
      "logs       logs       logs"
      "lighthouse lighthouse lighthouse"
    `,
  },
  [theme.mediaQueries.tablet]: {
    gridTemplateAreas: `
      "statusIcon statusText buildUrl "
      "deployIcon deployText cdnVendor"
      ".......... startTime  eventInfo"
      ".......... logs       logs"
      ".......... lighthouse lighthouse"
    `,
    gridTemplateColumns: `3rem 15rem 1fr`,
  },
})

export function BuildDetailsInfoLayout(props) {
  return <div css={rootCss} {...props} />
}

export function BuildDetailsStatusIconSlot(props) {
  return (
    <div
      css={{
        gridArea: `statusIcon`,
        alignSelf: `center`,
      }}
      {...props}
    />
  )
}

export function BuildDetailsStatusTextSlot(props) {
  return (
    <div
      css={{
        gridArea: `statusText`,
        alignSelf: `center`,
      }}
      data-cy="buildDetails__statusText"
      {...props}
    />
  )
}

export function BuildDetailsBuildUrlSlot(props) {
  return (
    <div
      css={{
        gridArea: `buildUrl`,
        alignSelf: `center`,
        wordBreak: `break-word`,
      }}
      {...props}
    />
  )
}

export function BuildDetailsDeployIconSlot(props) {
  return (
    <div
      css={{
        gridArea: `deployIcon`,
        alignSelf: `center`,
        display: `flex`,
        alignItems: `center`,
        flexShrink: 0,
      }}
      {...props}
    />
  )
}

export function BuildDetailsDeployTextSlot(props) {
  return (
    <div
      css={{
        gridArea: `deployText`,
        alignSelf: `center`,
      }}
      {...props}
    />
  )
}

export function BuildDetailsCdnVendorSlot(props) {
  return (
    <div
      css={{
        gridArea: `cdnVendor`,
        alignSelf: `center`,
      }}
      {...props}
    />
  )
}

export function BuildDetailsStartTimeSlot(props) {
  return (
    <div
      css={{
        gridArea: `startTime`,
      }}
      {...props}
    />
  )
}

export function BuildDetailsEventInfoSlot(props) {
  return (
    <div
      css={{
        gridArea: `eventInfo`,
      }}
      {...props}
    />
  )
}

export function BuildDetailsLogsSlot(props) {
  return (
    <div
      css={theme => ({
        gridArea: `logs`,
        marginTop: theme.space[2],
        minWidth: 0,
      })}
      {...props}
    />
  )
}
